<template>
   <div class="hello" >
      <div>
      	<div class="calc_name">
      		<span class="font_name">{{ name }}</span>
      	</div>
      	  
      	<!-- <div :class="minus>0? 'calc_accow':'calc_accow_red'" ></div> -->
       
      	<div class="clear"></div>   	
      </div>
      <div>
      	<div class="minus_value">
      	    <div>
      	             <ul   style="text-align:left; padding-top:20px"  :class="minus>0? 'font_red':'font_green'" > 
      	                <li class="font_minus"> {{ minus >0 ? '+'+minus :  minus }}</li>
      	                <li class="font_unit">{{ unit }}</li> 
      	             </ul>

      	              <ul style="padding-top:22px;">
      	                    <li class="font_value">{{ value[0] }}</li><li class="font_unit_s">{{ unit }}</li> 
      	                    <li  :class="minus>0? 'accow_red':'accow_green'" > </li>
      	                    <li class="font_value">{{ value[1] }}</li><li class="font_unit_s">{{ unit }}</li>
      	              </ul> 
      	    </div> 
      	</div>
      	  
       <div v-if="minus===0"></div>
      	<div v-else :class="minus>0? 'arrow_big_red':'arrow_big'" ></div>
       
            <div class="clear"></div>
      </div> 
    </div> 
</template>

<script>
export default {
  // 接收父组件传过来的属性
  props: ['name', 'value', 'minus', 'unit']
}
</script>

<style scoped> 
 .arrow_big{
	width: 70px;
      height: 94px;
      background-repeat: no-repeat;
 	background-image:  url('~assets/images/down.png');
 	background-size:50px 70px;
 	background-position: center;
	float: right;
	display:inline;
 }

  .arrow_big_red{
	width: 70px;
      height: 94px;
      background-repeat: no-repeat;
 	background-image:  url('~assets/images/up.png');
 	background-size:50px 70px;
 	background-position: center;
	float: right;
	display:inline;
 }
</style>

 



// WEBPACK FOOTER //
// Calc.vue?16cb9f6c